function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgSuv = function SvgSuv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.967 1.853c-.556.009-1.142.02-1.762.034a.599.599 0 00-.542.376l-1.437 3.59h3.74v-4zm1.2-.016v4.016H14.8V1.979c-2.386-.119-4.546-.174-7.633-.142zm8.19-1.03C12.042.63 9.281.571 4.177.686l-.11.006a.608.608 0 00-.05-.002H2.13a.6.6 0 100 1.2h.39L.768 6.267a.6.6 0 00-.043.223v2.92l-.289.22a.6.6 0 00-.236.476v2c0 .273.066.645.196.987.121.321.353.76.781.98a.599.599 0 00.148.054l3.193.696a3.4 3.4 0 006.712.109h11.223a3.401 3.401 0 006.694 0H31.596c.12.003.303.007.454-.01.234-.029.513-.113.751-.356.515-.523.779-1.325.859-2.076.081-.757-.01-1.595-.346-2.24a.473.473 0 01-.067-.202V8.713c0-.552-.276-1.202-.954-1.432-.596-.203-1.506-.386-2.758-.596-.974-.164-2.183-.35-3.656-.575l-1.156-.177a34.1 34.1 0 01-1.557-2.143l-.258-.377c-.473-.685-.891-1.231-1.61-1.798-.45-.354-.991-.515-1.51-.547l-.705-.043a478.805 478.805 0 00-3.576-.21.604.604 0 00-.15-.009zM16 2.042v3.812l7.175.03a40.157 40.157 0 01-1.006-1.427l-.248-.363c-.448-.648-.786-1.08-1.366-1.538-.218-.171-.51-.271-.84-.291l-.71-.044c-1.098-.067-2.08-.127-3.005-.179zm8.353 5.047L15.4 7.053H1.925v2.653a.6.6 0 01-.237.478l-.288.22v1.702c0 .113.034.341.118.561a.918.918 0 00.176.312l2.867.625a3.401 3.401 0 016.669.128h11.223a3.401 3.401 0 016.694 0h2.365l.133.001h.017l.094.002a1.233 1.233 0 00.187-.011.083.083 0 00.005-.002c.25-.256.454-.752.519-1.36.064-.603-.023-1.185-.217-1.559a1.642 1.642 0 01-.203-.755V8.713a.439.439 0 00-.053-.221.155.155 0 00-.086-.075c-.492-.167-1.31-.337-2.573-.55-.964-.161-2.16-.345-3.63-.57l-1.352-.207zM14.4 8.106a.6.6 0 01.6-.6h1.6a.6.6 0 010 1.2H15a.6.6 0 01-.6-.6zm-6.517 4.026a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4zm17.917 0a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4z",
    fill: props.color
  }));
};
SvgSuv.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgSuv.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgSuv;